import { computed } from 'vue';
import {
  getUserPermissions,
  getUserRole,
} from 'dashboard/helper/permissionsHelper';

const GENERAL_MANAGER_PERMISSION = 'post_sale_assign';

export function useSalesListPresentation({
  t,
  dashboard,
  activeList,
  currentUser,
  accountId,
}) {
  const sectionTabs = computed(() => [
    {
      id: 'painel',
      label: t('SALES.SECTIONS.OVERVIEW'),
      icon: 'i-lucide-house',
    },
    {
      id: 'vendas',
      label: t('SALES.SECTIONS.SALES'),
      icon: 'i-lucide-building-2',
    },
  ]);
  const listTabs = computed(() =>
    [
      ['rascunhos', t('SALES.LISTS.DRAFTS')],
      ['revisoes', t('SALES.LISTS.REVIEW')],
      ['entregues', t('SALES.LISTS.DELIVERED')],
      ['arquivados', t('SALES.LISTS.TRASH')],
      ['finalizados', t('SALES.LISTS.FINISHED')],
    ].map(([id, label]) => ({
      id,
      label,
      badge: dashboard.value.counts?.[id] || 0,
    }))
  );
  const sortVisible = computed(() =>
    ['rascunhos', 'revisoes', 'entregues'].includes(activeList.value)
  );
  const showManager = computed(() => {
    const user = currentUser.value;
    return (
      getUserRole(user, accountId) === 'administrator' ||
      getUserPermissions(user, accountId).includes(GENERAL_MANAGER_PERMISSION)
    );
  });

  return { listTabs, sectionTabs, showManager, sortVisible };
}
